import React from 'react'
import TodoItem from "./TodoItem";
import { useState } from 'react';

const Todos = (props) => {
  // let mystyle = {
  //   minHeight : "60vh",
  //   margin : "40px auto",
  //   background:"cornsilk"
  // }
  const [mode, setMode] = useState('light');//dark mode on or off

  const togglemode=()=>{
    if(mode === 'light'){
      setMode('dark');
      document.body.style.backgroundColor = '#131417';
    }
    else{
      setMode('light');
      document.body.style.backgroundColor = 'white';
    }
  }

  return (
    <>
    <div className='container' style={{backgroundColor: props.mode === 'dark'?'#2C3333':'cornsilk',color:props.mode === 'dark'?'white':'black',minHeight : "60vh",margin : "40px auto"}} >
        <h3 className= 'my-3' style={{backgroundColor: props.mode === 'dark'?'#064663':'#FFD369',color:props.mode === 'dark'?'white':'black'}}><b>Todos List</b></h3>
        {props.todos.length===0? "No Todos Available To Display":
         props.todos.map((todo)=>{
            return <TodoItem todo = {todo} key={todo.sno} onDelete={props.onDelete} mode = {mode} togglemode={togglemode}/>
        })
          }
          
    </div>
    </>
  )
}

export default Todos

// #FFD369'